<!--
 * @Author: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @Date: 2024-05-30 16:31:33
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-06-20 11:49:17
 * @FilePath: /front-vps-admin/src/web-framework/components/OrganSelector/index.vue
 * @Description: 聚合资源主体下拉选择器
-->
<template>
    <el-select v-model="selectedValue" @change="handleChange" :size="size" :placeholder="placeholder">
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
    </el-select>
</template>
<script>
import CustomerAPI from "@/web-framework/api/customer.js";
export default {
    props: {
        type: {
            type: Number,
            required: true,
        },
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'mini'
        },
        onChange: {
            type: Function,
            defualt: null
        }
    },
    data() {
        return {
            selectedValue: this.value, // 初始化为父组件传入的值
            options: []
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let promises = [];
            if ((this.type & this.Constants.CustomerType.Power) == this.Constants.CustomerType.Power)
                promises.push(CustomerAPI.searchCustomer('customerPower', {}));
            if ((this.type & this.Constants.CustomerType.Loader) == this.Constants.CustomerType.Loader)
                promises.push(CustomerAPI.searchCustomer('customerLoader', {}));
            if ((this.type & this.Constants.CustomerType.EnergyStorage) == this.Constants.CustomerType.EnergyStorage)
                promises.push(CustomerAPI.searchCustomer('customerEnergyStorage', {}));


            Promise.all(promises).then(results => {
                results.forEach(item => {
                    if (item.data) {
                        item.data.forEach(row => {
                            this.options.push(row);
                        });
                    }
                });
            });
        },
        handleChange(value) {
            // 触发事件，将选择的值传递回父组件
            this.$emit('input', value);

            if (typeof this.callback === 'function') {
                this.onChange(value); // 调用父组件传递的回调函数
            }
        }
    },
    watch: {
        // 确保当父组件的v-model值变化时，子组件的v-model也能同步更新
        value(newValue) {
            this.selectedValue = newValue;
        }
    }
};
</script>